<ng-container *ngIf="!modoSomenteLeitura">
  <div class="col mt-3 mb-4" *ngIf="imagensList?.length && multiple || !imagensList?.length">
    <nz-divider [nzText]="titulo" nzOrientation="left"></nz-divider>
    <nz-upload nzType="drag" [nzMultiple]="multiple" [nzBeforeUpload]="beforeUpload" [(nzFileList)]="fileList"
      nzShowDownload="false" [nzAccept]="tiposAceito">
      <p class="ant-upload-drag-icon mb-1">
        <span class="pajamas--upload fs-1"></span>
      </p>
      <p class="ant-upload-text">{{ titulo }}</p>
      <p class="ant-upload-hint">
        <span class="text-secondary-color">
          Clique ou arraste o arquivo para esta área para fazer upload
        </span>
      </p>
    </nz-upload>

    <!-- <div class="col-12 mt-2">
      <ng-container *ngIf="fileList.length > 0">
        <div class="d-flex justify-content-between align-items-center">
          <label nz-checkbox [(ngModel)]="selectAllFileList" (ngModelChange)="toggleAllSelection($event, fileList)" class="me-3">
            Selecionar Todos
          </label>
          <div class="d-flex align-items-center col-9">
            <input nz-input [(ngModel)]="descricaoGeralInterna" placeholder="Alterar descrição dos selecionados" class="w-100 me-2" />
            <button nz-button nzType="default" nzSize="small" type="button" 
              (click)="editarSelecionados(fileList, descricaoGeralInterna)"
              nz-popover nzPopoverContent="Altera a descrição de todos itens selecionados">
              Alterar
            </button>
            <button nz-button nzType="primary" nzSize="small" class="ms-2" type="button"
            nz-popover nzPopoverContent="Salva a descrição de todos os itens dessa lista" 
            (click)="salvarListaUpload(fileList)">
              Salvar
            </button>
          </div>
        </div>
      </ng-container>
      <nz-divider class="mt-1 mb-1"/>
      
      <ng-container *ngFor="let item of fileList">
        <div class="col-12 py-1 d-flex align-items-center justify-content-between view-image">
          <div class="d-flex align-items-center">
            <label nz-checkbox [(ngModel)]="item.selected" class="me-2"></label>
            <span nz-icon nzType="paper-clip" nzTheme="outline" class="small ps-1 me-2"></span>
            <p class="p-0 me-2 mt-2">{{ item?.name }}</p>
          </div>
        
          <div class="d-flex align-items-center w-75">
            <input nz-input [(ngModel)]="item.descricao" placeholder="Descrição do arquivo" class="flex-grow-1 me-2" [maxLength]="50" />
            <button nz-button nzType="text" nzSize="small" nz-popover nzPopoverContent="Remover Imagem"
              nzPopoverPlacement="topRight" type="button" (click)="removeItem(item)">
              <span nz-icon nzType="delete" nzTheme="outline"></span>
            </button>
          </div>
        </div>
      </ng-container>
    </div> -->
  </div>
</ng-container>
<div class="col mb-4 px-3" *ngIf="imagensList?.length">
  <nz-divider nzText="Arquivos Adicionados" nzOrientation="left"></nz-divider>

  <!-- Cabeçalho da lista -->
  <div class="row fw-bold border border-secondary-subtle py-2 align-items-center" [ngClass]="{ 'bg-secondary': allSelected }">
    <div class="col-auto text-center">
      <label nz-checkbox [ngModel]="allSelected" (ngModelChange)="toggleAllSelection($event, imagensList)" [nzDisabled]="modoSomenteLeitura">
      </label>      
    </div>
    <div class="col">Selecionar Todos</div>
    <div class="col-6 d-flex align-items-center">
      <input nz-input [(ngModel)]="descricaoGeralExterna" placeholder="Descrição para selecionados" class="w-100 me-2" [disabled]="modoSomenteLeitura" />
      <button nz-button nzType="primary" nzSize="large" type="button"
        (click)="editarSelecionados(imagensList, descricaoGeralExterna)" [disabled]="modoSomenteLeitura">
        <span nz-icon nzType="edit"></span> Alterar Selecionados
      </button>
    </div>
    <div class="col-auto text-center" *ngIf="habilitarExclusaoEmLote">
      <button nz-button nzType="primary" nzSize="large" type="button" class="btn-primary-color"
        (click)="removeSelectedImages()" [disabled]="modoSomenteLeitura || !hasSelectedImages">
        <span nz-icon nzType="delete"></span> Excluir Selecionados
      </button>
    </div>
  </div>

  <nz-divider class="mt-1 mb-1"/>

  <!-- Itens da lista -->
  <div class="row border border-dark-subtle py-2 align-items-center"
    *ngFor="let item of imagensList" [ngClass]="{ 'bg-secondary': item.selected }">
    
    <!-- Checkbox individual -->
    <div class="col-auto text-center">
      <label nz-checkbox [(ngModel)]="item.selected" [nzDisabled]="modoSomenteLeitura"></label>
    </div>

    <!-- Nome do arquivo -->
    <div class="col">{{ item['originalFileName'] }}</div>

    <!-- Campo de descrição -->
    <div class="col-5">
      <input nz-input [(ngModel)]="item.descricao" placeholder="Descrição do arquivo" class="w-100" [maxLength]="50" [disabled]="modoSomenteLeitura" />
    </div>

    <!-- Botões de ação -->
    <div class="col-1 text-center d-flex">
      <button nz-button nzType="primary" nzSize="large" nzShape="circle"
        nz-tooltip="Visualizar detalhes" type="button"
        (click)="modalDescricao(item['id'])">
        <span nz-icon nzType="search"></span>
      </button>

      <ng-container *ngIf="!modoSomenteLeitura">
        <button nz-button nzType="default" nzSize="large" nzShape="circle"
          nz-tooltip="Deletar arquivo" type="button"
          (click)="removeImage(item)" class="ms-2">
          <span nz-icon nzType="delete"></span>
        </button>
      </ng-container>
    </div>
  </div>
</div>